import { render, staticRenderFns } from "./reportProductSale.vue?vue&type=template&id=c3fb0850&scoped=true"
import script from "./reportProductSale.vue?vue&type=script&lang=js"
export * from "./reportProductSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fb0850",
  null
  
)

export default component.exports